import { render, staticRenderFns } from "./File-Icon.vue?vue&type=template&id=a9727112&scoped=true&functional=true&"
var script = {}
import style0 from "./File-Icon.vue?vue&type=style&index=0&id=a9727112&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "a9727112",
  null
  
)

export default component.exports